var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Ref } from 'vue-property-decorator';
import { BFormGroup, BFormSelect, BFormInput, BFormRadioGroup, BButton, BFormTextarea, BRow, BCol, BFormCheckbox, BFormRow, ModalPlugin } from 'bootstrap-vue';
import vue2Dropzone from 'vue2-dropzone';
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios';
Vue.use(ModalPlugin);
let QuoteForm = class QuoteForm extends Vue {
    constructor() {
        super(...arguments);
        this.formData = {
            enquiry: 'frames',
            standard: 'recommended',
            description: '',
            images: [],
            colour: '',
            style: 'plain',
            name: '',
            email: '',
            phone: '',
            location: 'uk',
            recaptcha: ''
        };
        this.contactEnabled = false;
        this.enquiryTypes = [
            { text: 'Bespoke Picture Frame(s)', value: 'frames' },
            { text: 'Cut to Size Mounts & Mount Kits', value: 'mounts' },
            { text: 'DIY Framing & Chop Service', value: 'diy' },
            { text: 'Wholesale & Trade Framing', value: 'wholesale' },
            { text: 'Custom Mirrors', value: 'mirrors' }
        ];
        this.framingStandards = [
            { text: 'Budget', value: 'budget' },
            { text: 'Recommended', value: 'recommended' },
            { text: 'Conservation', value: 'conservation' },
            { text: 'Museum', value: 'museum' }
        ];
        this.styles = [
            { text: 'Plain', value: 'plain' },
            { text: 'Wood Grain', value: 'grain' },
            { text: 'Distressed', value: 'distressed' },
            { text: 'Ornate', value: 'ornate' },
            { text: 'Swept', value: 'swept' },
            { text: 'Barefaced', value: 'barefaced' }
        ];
        this.locations = [
            { text: 'Local to Derbyshire', value: 'local' },
            { text: 'United Kingdom', value: 'uk' },
            { text: 'International / Overseas', value: 'international' }
        ];
        this.dropzoneOptions = {
            url: '/api/quote/image',
            maxFilesize: 2,
            maxFiles: 10,
            uploadMultiple: true,
            acceptedFiles: 'image/jpeg',
            dictDefaultMessage: 'Click here or drag and drop files to upload'
        };
        this.recaptchaKey = process.env.RECAPTCHA_KEY;
        this.quoteSentMessage = 'Your quote request has been sent.  Please allow 1-2 business days for us to reply.';
        this.quoteFailedMessage = 'Sorry, an error occured while sending your quote.  Please contact us directly via e-mail or telephone.';
    }
    get isSubmitDisabled() {
        return !this.contactEnabled;
    }
    imagesUploaded(files, response) {
        response.forEach(item => this.formData.images.push(item));
    }
    recaptchaVerified(response) {
        return __awaiter(this, void 0, void 0, function* () {
            this.formData.recaptcha = response;
            try {
                const { data } = yield axios
                    .post('/api/quote/submit', this.formData);
                yield this.$bvModal.msgBoxOk(data.success ? this.quoteSentMessage : this.quoteFailedMessage, {
                    title: data.success ? 'Quote Request Sent' : 'Quote Request Failed',
                });
                location.reload();
            }
            catch (e) {
                this.$bvModal.msgBoxOk('Failed to send quote request at this time. Please try again later.', { title: 'Error' });
            }
        });
    }
    recaptchaExpired() {
        this.$bvModal.msgBoxOk(this.quoteFailedMessage);
    }
};
__decorate([
    Ref('recaptcha')
], QuoteForm.prototype, "recaptcha", void 0);
QuoteForm = __decorate([
    Component({
        components: {
            "vue-dropzone": vue2Dropzone, VueRecaptcha, BFormGroup, BFormSelect, BFormInput, BFormRadioGroup, BButton, BFormTextarea, BRow, BCol, BFormCheckbox, BFormRow
        }
    })
], QuoteForm);
export default QuoteForm;
